// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"488":"axiom","532":"styles","592":"common","736":"vendor"}[chunkId] || chunkId) + "." + {"488":"335ab047b82806214832","532":"59f8ba85c8915f291141","569":"86d0c80464ece9bcad8f","592":"540a187630423cb79047","736":"7407794801657b0434a8"}[chunkId] + ".js";
};